module.exports = __webpack_public_path__ + "img/logo_funambule.697c8885.png";